<template>
    <div class="job-opening-card bg-white p-4 cursor-pointer h-100 d-flex flex-column justify-content-between" @click="handleCardClick">
        <div :class="`opening-card-header d-flex align-items-center}`">
            <div>
                <img :src=job1 alt="">
              <p class="lead job-title mb-0">{{ $t(job.title) | truncate}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import {formatDateToLocal} from "../../../Helpers/DateTimeHelper";
import {ucFirst} from "../../../Helpers/TextHelper";
import {numberFormatter} from "../../../Helpers/Helpers";
import {urlGenerator} from "../../../Helpers/AxiosHelper";
import {TENANT_BASE_URL} from "../../../Config/UrlHelper";
export default {
	props: ['job'],
    filters: {
        truncate(value) {
            if (!value) return;
            const limit = 40;
            if (value.length < limit) return value;
            return value.substring(0, limit) + '...'
        }
    },
    data() {
       return {
           formatDateToLocal,
           ucFirst,
           numberFormatter
       }
    },
    methods: {
		handleCardClick() {
			window.location.assign(this.job.url);
		}
    },
  computed: {
    job1() {
      return urlGenerator('/images/'+ this.job.title+'.jpg');
    }
  }
}
</script>

<style lang="scss" scoped>

img {
  border-radius: 8px;
}

</style>
